import axios from 'axios';

const API_URL = '/api';

export const ACCESS_TOKEN = 'accessToken';

export const serviceGetUser = () => {
    return axios.get(API_URL + '/auth/user');
};

export const serviceLogin = (email: string, password: string) => {
    return axios.post(API_URL + '/auth/login', {
        email: email.toLowerCase(),
        password
    });
};

export const serviceLogout = () => {
    localStorage.removeItem(ACCESS_TOKEN);
};

export const serviceSendPasscode = (email: string) => {
    return axios.post(API_URL + '/auth/send-password', null, {
        params: { email }
    });
};

